import React from 'react';
import classNames from '../../../helpers/classNames.js';
const ModalContent = ({
  children,
  type
}) => {
  const wrapperClassNames = classNames('ebds-modal__content', {
    [`--${type}`]: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames,
    role: "alert",
    "aria-live": "assertive"
  }, children);
};
export default ModalContent;